<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订货单位<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item ref="formItem" prop="orderUnitCode">
            {{ form.orderUnit }} <el-button v-if="enableChange || isSelect" type="text" style="padding: 0 10px" @click="orderCompany">
              选择
            </el-button>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订货单位编码：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="orderUnitPhone">
            {{ form.orderUnitCode }}
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订货单位电话：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="orderUnitPhone">
            <el-input v-model="form.orderUnitPhone" />
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div v-if="isShowEsing" class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          采购类型：
        </div>
        <div class="rj-baseinfo__item">
          {{ form.purchaseType }}
        </div>
      </div>
    </div>
    <el-dialog title="选择订货单位" :visible.sync="dialogTableVisible" width="800px">
      <el-row :gutter="20" style="margin-top: -14px;margin-bottom: 10px">
        <el-form ref="form" label-width="100px">
          <el-col :span="10">
            <el-form-item label="订货单位编号:">
              <el-input v-model="orderUnit.strAgentID" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="订货单位名称:">
              <el-input v-model="orderUnit.strAgentName" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="handleCurrentChange(1)">
              查询
            </el-button>
          </el-col>
        </el-form>
      </el-row>
      <el-table
        v-loading="loading"
        :data="orderUnitData"
        border style="width: 100%;" max-height="500"
      >
        <el-table-column prop="" :resizable="false" label="选择" align="left" fixed="left" width="80px">
          <template slot-scope="scope">
            <el-button type="text" @click="select(scope.row)">
              选择
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="finalCustomerID" :resizable="false" label="订货单位编号" width="130" align="left" />
        <el-table-column prop="finalCustomerName" :resizable="false" label="订货单位名称" min-width="180" align="left" />
        <el-table-column prop="agenrType" :resizable="false" label="签约类型" min-width="120" align="left" />
        <el-table-column prop="isCustomerActived" :resizable="false" label="当前状态" width="90" align="left">
          <template v-slot="{row}">
            {{ row.isCustomerActived ? '启用' : '停用' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align: right;padding-top: 10px">
        <el-pagination
          :current-page="page.currentPage"
          :page-size="page.pagesize"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { getOrderUnitList } from '@/API';
export default {
  data () {
    return {
      loading: false,
      dialogTableVisible: false,
      orderUnit: {
        strAgentID: '',
        strAgentName: ''
      },
      page: {
        currentPage: 1,
        pagesize: 10,
        total: 0
      },
      orderUnitData: []
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    },
    enableChange: {
      type: Boolean,
      default: true
    },
    isSelect: {
      type: Boolean,
      default: true
    },
    isShowEsing: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    orderCompany () {
      this.dialogTableVisible = true;
      this.handleCurrentChange(1);
    },
    search () {
      this.loading = true;
      getOrderUnitList({
        ...this.orderUnit,
        pageSize: this.page.pagesize,
        pageIndex: this.page.currentPage
      }).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.orderUnitData = json.data.dt;
          this.page.total = json.data.totalCount;
          if (!this.orderUnitData.length) this.$message.info('未查询到该客户');
        } else {
          this.$message.error(json.message || '查询客户失败');
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('查询客户失败');
      });
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.search();
    },
    select (row) {
      this.$set(this.form, 'orderUnit', row.finalCustomerName);
      this.$set(this.form, 'orderUnitCode', row.finalCustomerID);
      this.$set(this.form, 'customerContractType', row.agenrType);
      this.dialogTableVisible = false;
      this.$emit('changeOrderUnit', row);
      this.$refs.formItem.validate('change');
    }
  },
  mounted () {
  }
};
</script>
